import { useEffect, useState, ReactNode } from "react";
import { AdminThemeContext } from "./adminThemeDefs";
import type { AdminTheme } from "./adminThemeDefs";

export type { AdminTheme } from "./adminThemeDefs";
export { AdminThemeContext } from "./adminThemeDefs";

const STORAGE_KEY = "forward_admin_theme";

function getSystemTheme(): "light" | "dark" {
  if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }
  return "light";
}

export function AdminThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<AdminTheme>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark" || stored === "system") {
      return stored;
    }
    return "system";
  });

  const [systemTheme, setSystemTheme] = useState<"light" | "dark">(
    getSystemTheme,
  );

  // Listen for system color scheme changes
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e: MediaQueryListEvent) => {
      setSystemTheme(e.matches ? "dark" : "light");
    };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const setTheme = (newTheme: AdminTheme) => {
    setThemeState(newTheme);
    localStorage.setItem(STORAGE_KEY, newTheme);
  };

  const effectiveTheme = theme === "system" ? systemTheme : theme;

  return (
    <AdminThemeContext.Provider value={{ theme, effectiveTheme, setTheme }}>
      {children}
    </AdminThemeContext.Provider>
  );
}
